<template>
  <div>Home Products</div>
</template>

<script>
export default {};
</script>